var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('users-hub-selector',_vm._g(_vm._b({staticClass:"users-hub-filter",attrs:{"formattedValue":_vm.formattedSelectedHubs,"position":"is-bottom-left","multiple":""}},'users-hub-selector',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }